import { FeatureReferenceCollection, } from './features/index.js';
import { DataReferenceCollection, DataImplementation, } from './data/index.js';
import { FromSeekAPI } from './adapters/index.js';
const { PatternType } = FeatureReferenceCollection.Query;
/**
 * @classdesc
 * A class capable of transforming collections of "reference" objects into
 * variants. Including moving from a zero dimensional to one dimensional list
 * etc.
 */
class ReferencesTransformer {
    /**
     * @param {feature-references.FeatureReferenceCollection[]} featureReferenceCollections
     * @param {data-references.DataReferenceCollection[]} dataReferenceCollections
     * @param {data-references.DataImplementation[]} dataimplementations
     */
    constructor({ featureReferenceCollections, dataReferenceCollections, dataImplementations, }) {
        this.featureReferenceCollections = featureReferenceCollections;
        this.dataReferenceCollections = dataReferenceCollections;
        this.dataImplementations = dataImplementations;
    }
    /**
     * @return {?feature-references.FeatureReferenceCollection}
     */
    getSpatialQueryCollection() {
        const queries = this.featureReferenceCollections.filter((collection) => collection.isDynamic);
        const spatialQuery = queries.find((collection) => collection.query.pattern === PatternType.SPATIAL_QUERY);
        return spatialQuery;
    }
    /**
     * @return {?feature-references.FeatureReferenceCollection}
     */
    getConstrainByCollection() {
        const spatialQuery = this.getSpatialQueryCollection();
        if (!spatialQuery)
            return spatialQuery;
        const { constrainBy } = spatialQuery.query.parameters;
        const collection = FeatureReferenceCollection.fromFeatureReferences([constrainBy]);
        return collection;
    }
    /**
     * @return {data-references.DataImplementation}
     */
    toOneDataImplementation() {
        const consolidated = new DataImplementation({ ref: new DataReferenceCollection() });
        const hasAnyNormalization = this.dataImplementations.some(imp => imp.hasNormalization);
        if (hasAnyNormalization) {
            consolidated.normalization.ref = new DataReferenceCollection();
        }
        // TODO: Support for queries
        this.dataImplementations.forEach((implementation) => {
            var _a;
            consolidated.ref.variables.push(...implementation.ref.variables);
            if (hasAnyNormalization) {
                const fallback = arrayOf(implementation.ref.variables.length, null);
                const denominator = (_a = implementation.normalization.ref.variables) !== null && _a !== void 0 ? _a : fallback;
                consolidated.normalization.ref.variables.push(...denominator);
            }
            consolidated.overrides.push(...implementation.overrides);
            // QUESTION: How should we handle consolidation of selection metadata
        });
        return consolidated;
    }
    /**
     * @param {*} dataImplementations
     * @param {*} dataReferenceCollections
     * @param {*} featureReferenceCollections
     * @return {ReferencesTransformer}
     */
    static fromSeekAPI({ dataImplementations, dataReferenceCollections, featureReferenceCollections, }) {
        return new ReferencesTransformer(FromSeekAPI.collections({
            dataImplementations,
            dataReferenceCollections,
            featureReferenceCollections,
        }));
    }
}
/**
 * @param {number} num
 * @param {*} value
 * @return {Array<*>}
 * @private
 */
function arrayOf(num, value) {
    const placeholder = 0;
    return new Array(num).fill(placeholder).map(() => value);
}
export default ReferencesTransformer;
